// extracted by mini-css-extract-plugin
module.exports = {"AuthFormContainer":"Auth_AuthFormContainer__37Wqn","Link":"Auth_Link__1SKw2"};